import { LogLevel } from './types';
export function defineLogger({ factory, config = {} }) {
    const logger = factory();
    return {
        debug(event, entity, metaData) {
            if (!this.minLogLevel || this.minLogLevel <= LogLevel.DEBUG) {
                logger.debug(event, entity, metaData);
            }
        },
        info(event, entity, metaData) {
            if (!this.minLogLevel || this.minLogLevel <= LogLevel.INFO) {
                logger.info(event, entity, metaData);
            }
        },
        warn(event, entity, metaData) {
            if (!this.minLogLevel || this.minLogLevel <= LogLevel.WARN) {
                logger.warn(event, entity, metaData);
            }
        },
        error(event, entity, metaData) {
            if (!this.minLogLevel || this.minLogLevel <= LogLevel.ERROR) {
                logger.error(event, entity, metaData);
            }
        },
        minLogLevel: config.minLogLevel,
    };
}
//# sourceMappingURL=define-logger.js.map